import { useState, useEffect } from 'react';
import { listenToDocument } from '../services/firestore.service';

export const usePlotDetail = (plotId) => {
  const [plot, setPlot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!plotId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsubscribe = listenToDocument(
      'plots',
      plotId,
      (data) => {
        setPlot(data);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [plotId]);

  return { plot, loading, error };
};

